import React from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Modal from '../Modal/Modal';
import Text from '../Text/Text';
import { ReactComponent as IconOkCircle } from '../../assets/icon/ic_ok_circle.svg';
import { setApplicationState } from '../../actions/application/application';

const TableSettingModal = ({
  visible, toggleVisible, title, list, values, onSelect
}) => {
  const dispatch = useDispatch();
  const {
    application: { isCoOrderHeaderFixed },
  } = useSelector((state) => ({
    application: state?.application,
  }), shallowEqual);

  return (
    <Modal
      visible={visible}
      toggleVisible={toggleVisible}
      title={title}
      hideSaveBtn
    >
      <div className="customScroll w-[700px] overflow-auto px-[10px]">
        <div className="flex flex-row pb-[20px] border-b border-[#EFF2F5] dark:border-[#1b263b] mb-[20px]">
          <button
            type="button"
            className={`flex items-center gap-[8px] px-[12px] py-[8px] rounded-[8px] border text-[13px]
              ${isCoOrderHeaderFixed
            ? 'bg-primary-light text-primary border-primary/40 dark:bg-[#415a77] dark:text-white'
            : 'bg-transparent text-text-main border-whiteHover dark:border-[#1b263b] dark:text-[#e0e1dd]'}
            `}
            onClick={() => {
              dispatch(setApplicationState({
                isCoOrderHeaderFixed: !isCoOrderHeaderFixed
              }));
            }}
          >
            <span className={`inline-flex items-center justify-center w-[20px] h-[20px] rounded-[4px] border
              ${isCoOrderHeaderFixed
            ? 'border-primary bg-primary text-white'
            : 'border-[#778da9] bg-white dark:bg-[#0d1b2a]'}
            `}
            >
              {isCoOrderHeaderFixed ? <IconOkCircle width={18} height={18} /> : ''}
            </span>
            Fixed Header
          </button>
        </div>
        <div className="grid grid-cols-2 gap-x-[24px] gap-y-[12px]">
          {list.map(({ source, title: itemTitle, selectable }) => (
            <button
              type="button"
              key={source}
              disabled={!selectable}
              onClick={() => onSelect(source)}
              className={`flex flex-col items-start gap-[2px] w-full text-left px-[12px] py-[10px]
                rounded-[8px] border transition-all duration-200
                ${!selectable ? 'opacity-40 cursor-not-allowed' 
                : 'hover:border-primary hover:bg-primary-light dark:hover:bg-[#1b263b]'}
                ${values?.includes(source) || !selectable
            ? 'border-primary/40 bg-primary-light text-primary dark:bg-[#415a77] dark:text-white'
            : 'border-whiteHover text-text-main dark:border-[#1b263b] dark:text-[#e0e1dd]'}
              `}
            >
              <div className="flex items-center gap-[8px]">
                <span className={`inline-flex items-center justify-center 
                w-[20px] h-[20px] rounded-[4px] border text-[11px]
                  ${values?.includes(source) || !selectable
            ? 'border-primary bg-primary text-white dark:border-white/60 dark:bg-white/20'
            : 'border-[#778da9] bg-white dark:bg-[#0d1b2a]'}
                `}
                >
                  {(values?.includes(source) || !selectable) ? <IconOkCircle width={18} height={18} /> : ''}
                </span>
                <span className="text-[13px] font-medium capitalize">{itemTitle}</span>
              </div>
              <div className="flex items-center gap-[6px]">
                <Text muted text={source} textStyle="text-[10px]" />
                <button
                  type="button"
                  className="text-[10px] text-primary hover:underline"
                  onClick={(event) => {
                    event.stopPropagation();
                    navigator.clipboard.writeText(source);
                  }}
                >
                  Copy
                </button>
              </div>
            </button>
          ))}
        </div>
      </div>
    </Modal>
  );
};

TableSettingModal.propTypes = {
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func,
  onSelect: PropTypes.func,
  list: PropTypes.arrayOf(PropTypes.shape({})),
  values: PropTypes.arrayOf(PropTypes.string)
};

TableSettingModal.defaultProps = {
  visible: false,
  toggleVisible: () => {},
  onSelect: () => {},
  list: [],
  values: [],
};

export default TableSettingModal;
